<svg-icon-sprite
  [src]="'./assets/img/icons/sprite.svg#close'"
  mat-dialog-close
  class="close">
</svg-icon-sprite>

<h3 class="title" translate="deposit-bonus.terms.withdraw.title"></h3>
<p class="text" translate="deposit-bonus.terms.withdraw.text1"></p>
<p class="text" translate="deposit-bonus.terms.withdraw.text2"></p>

<div class="example">
  <div class="example__item">
    <span class="subtitle" translate="deposit-bonus.terms.withdraw.example.title1">
      <ng-container *ngTemplateOutlet="arrowIcon"></ng-container>
    </span>
    <span class="equity" translate="deposit-bonus.terms.withdraw.example.equity1"></span>
    <span class="equity-detail" translate="deposit-bonus.terms.withdraw.example.balance1"></span>
    <span class="equity-detail" translate="deposit-bonus.terms.withdraw.example.bonus1"></span>
  </div>
  <div class="example__item">
    <span class="subtitle" translate="deposit-bonus.terms.withdraw.example.title2">
      <ng-container *ngTemplateOutlet="arrowIcon"></ng-container>
    </span>
    <span class="equity" translate="deposit-bonus.terms.withdraw.example.equity2"></span>
    <span class="equity-detail" translate="deposit-bonus.terms.withdraw.example.balance2"></span>
    <span class="equity-detail" translate="deposit-bonus.terms.withdraw.example.bonus2"></span>
  </div>
  <div class="example__item">
    <span class="subtitle" translate="deposit-bonus.terms.withdraw.example.title1"></span>
    <span class="equity" translate="deposit-bonus.terms.withdraw.example.equity3"></span>
    <span class="equity-detail" translate="deposit-bonus.terms.withdraw.example.balance3"></span>
    <span class="equity-detail" translate="deposit-bonus.terms.withdraw.example.bonus3"></span>
  </div>
</div>

<ng-template #arrowIcon>
  <svg-icon-sprite
    [src]="'./assets/img/icons/sprite.svg#arrow-side'"
    width="15px"
    height="8px"
    class="arrow">
  </svg-icon-sprite>
</ng-template>
